export enum LocalStorage {
  RecentlyViewedProducts = 'vp',
  }